import type {
  DiscardNoveltyCalcResultsRequest,
  RerunNoveltyCalcRequest,
  RunNoveltyCalcRequest,
  SaveNoveltyCalcResultsRequest,
} from '@/api';
import { getApiClient } from '@/api/client';
import { useMutation } from '@tanstack/react-query';

export const useCalculatePrices = () => {
  return useMutation({
    mutationFn: async (request: RunNoveltyCalcRequest) => {
      return getApiClient()
        .runNoveltyCalc(request)
        .then((res) => res);
    },
  });
};

export const useRerunCalculatePrices = () => {
  return useMutation({
    mutationFn: async (request: RerunNoveltyCalcRequest) => {
      return getApiClient()
        .rerunNoveltyCalc(request)
        .then((res) => res);
    },
  });
};

export const useSaveCalculation = () => {
  return useMutation({
    mutationFn: async (request: SaveNoveltyCalcResultsRequest) => {
      return getApiClient()
        .saveNoveltyCalcResults(request)
        .then((res) => res);
    },
  });
};

export const useDiscardCalculation = () => {
  return useMutation({
    mutationFn: async ({
      request,
      initOverrides,
    }: {
      request: DiscardNoveltyCalcResultsRequest;
      initOverrides?: RequestInit;
    }) => {
      return getApiClient()
        .discardNoveltyCalcResults(request, initOverrides)
        .then((res) => res);
    },
  });
};
